import React from "react";

const RatingScale = ({ question, answer, onAnswer }) => {
  const min = question.min ?? 0;
  const max = question.max ?? 10;
  const numbers = [];
  for (let i = min; i <= max; i++) {
    numbers.push(i);
  }

  return (
    <div className="tbb-quiz__field">
      <div className="tbb-quiz__rating-grid">
        {numbers.map((num) => (
          <button
            key={num}
            type="button"
            className={`tbb-quiz__rating-box${answer === num ? " tbb-quiz__rating-box--selected" : ""}`}
            onClick={() => onAnswer(num)}
          >
            {num}
          </button>
        ))}
      </div>
      <div className="tbb-quiz__rating-labels">
        <span>{question.minLabel || min}</span>
        {question.midLabel && (
          <span className="tbb-quiz__rating-label-mid">{question.midLabel}</span>
        )}
        <span>{question.maxLabel || max}</span>
      </div>
    </div>
  );
};

export default RatingScale;
